/**
 * Navigation Initialization
 * Initializes dropdown and mobile menu controllers for new navigation system
 * Only runs when new navigation is present (data-nav="main")
 */

import DropdownController from './dropdown-controller';
import MobileMenuController from './mobile-menu-controller';

// Store controller instances for cleanup
let dropdownControllers = [];
let mobileMenuController = null;

/**
 * Initialize navigation controllers
 */
function initializeNavigation() {
  // DOMContentLoaded and the initial Turbolinks load can both fire.
  cleanupNavigation();

  // Only initialize if new navigation is present
  const nav = document.querySelector('[data-nav="main"]');
  
  if (!nav) {
    // New navigation not active, skip initialization
    return;
  }
  
  console.log('Initializing new navigation system');
  
  // Initialize all dropdown containers
  const dropdownContainers = document.querySelectorAll('[data-dropdown-container]');
  dropdownContainers.forEach(container => {
    const controller = new DropdownController(container);
    dropdownControllers.push(controller);
  });
  
  console.log(`Initialized ${dropdownControllers.length} dropdown(s)`);
  
  // Initialize mobile menu
  mobileMenuController = new MobileMenuController(nav);
  console.log('Initialized mobile menu');
}

/**
 * Cleanup navigation controllers
 * Called before Turbolinks cache or page unload
 */
function cleanupNavigation() {
  // Destroy all dropdown controllers
  dropdownControllers.forEach(controller => controller.destroy());
  dropdownControllers = [];
  
  // Destroy mobile menu controller
  if (mobileMenuController) {
    mobileMenuController.destroy();
    mobileMenuController = null;
  }
  
  console.log('Cleaned up navigation controllers');
}

// Imports run before application.js calls Turbolinks.start(), which exposes
// window.Turbolinks. Register now so later visits always initialize the new body.
document.addEventListener('turbolinks:load', initializeNavigation);
document.addEventListener('turbolinks:before-cache', cleanupNavigation);
// Pages marked no-cache still replace their body, but never fire before-cache.
document.addEventListener('turbolinks:before-render', cleanupNavigation);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeNavigation);
} else {
  initializeNavigation();
}

// Cleanup on page unload (backup)
window.addEventListener('beforeunload', cleanupNavigation);

// Export for manual initialization if needed
export { initializeNavigation, cleanupNavigation };
